// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3gqL4","inputDescription":"styles_inputDescription__2UIGs"};